// extracted by mini-css-extract-plugin
export default {"modal":"ChangeModal-module--modal--640c6","address":"ChangeModal-module--address--d2a83"};